import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';


@Component({
  selector: 'app-edit-event-contact',
  templateUrl: './edit-event-contact.component.html',
  styleUrls: ['./edit-event-contact.component.scss']
})
export class EditEventContactComponent implements OnInit {
  formGroup: FormGroup;
  aviationEvent: AviationEvent;
  _origin_contactPersonName: string;
  _origin_contactPersonEmail: string;
  _origin_contactPersonPhone: string;
  isBusy = false;

  constructor(private _matDialogRef: MatDialogRef<EditEventContactComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService) {
    this.aviationEvent = data.aviationEvent;
    this._origin_contactPersonName = this.aviationEvent.contactPersonName;
    this._origin_contactPersonEmail = this.aviationEvent.contactPersonEmail;
    this._origin_contactPersonPhone = this.aviationEvent.contactPersonPhone;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    this.formGroup = new FormGroup({
      contactPersonName: new FormControl(this.aviationEvent.contactPersonName, [Validators.required, Validators.maxLength(256)]),
      contactPersonEmail: new FormControl(this.aviationEvent.contactPersonEmail, [Validators.required, Validators.maxLength(256)]),
      contactPersonPhone: new FormControl(this.aviationEvent.contactPersonPhone, [Validators.required, Validators.maxLength(256)])
    });
  }

  cancel () {
    this.aviationEvent.contactPersonName = this._origin_contactPersonName;
    this.aviationEvent.contactPersonEmail = this._origin_contactPersonEmail;
    this.aviationEvent.contactPersonPhone = this._origin_contactPersonPhone;
    this._matDialogRef.close(null);
  }

  async save () {
    if (this.aviationEvent.contactPersonName) {
      this.aviationEvent.contactPersonName = this.aviationEvent.contactPersonName.trim();
    }
    if (this.aviationEvent.contactPersonEmail) {
      this.aviationEvent.contactPersonEmail = this.aviationEvent.contactPersonEmail.trim();
    }
    if (this.aviationEvent.contactPersonPhone) {
      this.aviationEvent.contactPersonPhone = this.aviationEvent.contactPersonPhone.trim();
    }
    try {
      this.isBusy = true;
      await this._aviationEventsService.updateAviationEvent(this.aviationEvent);
      this.isBusy = false;
      this._matDialogRef.close(true);
    } catch (e) {
      this.isBusy = false;
      this._matDialogRef.close(false);
    }
  }
}
